























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import UserApi from '@/api/user'

let timer: any = ''

@Component({})
export default class Login extends Vue {
	@Prop()
	private visible!: any

	@Prop()
	private message!: any

	@Prop()
	private formData!: any

	@Prop()
	private loading!: any

	private form: any = ''
	private txt: any = '获取验证码'
	private disabled: boolean = false

	private created() {
		this.form = this.$form.createForm(this)
	}

	private get mobile() {
		const mobile = (this.$store.getters.userInfo.mobile || '').split('')
		for (let i = 3; i < 7; i++) {
			mobile[i] = '*'
		}
		return mobile.join('')
	}

	private handleSubmit(e: any) {
		e.preventDefault()
		this.form.validateFields((err: any, values: any) => {
			if (!err) {
				this.$emit('ok', {
					...this.formData,
					smsCode: values.code,
				})
			}
		})
	}

	private async getForgotPwdValidateCode() {
		this.form.resetFields(['code'])
		try {
			this.disabled = true
			let sec = 60
			this.txt = `已发送(${sec}s)`
			clearInterval(timer)
			timer = setInterval(() => {
				sec--
				if (sec <= 0) {
					this.disabled = false
					clearInterval(timer)
					this.txt = '重新发送短信'
					return
				}
				this.txt = `已发送(${sec}s)`
			}, 1000)
			await UserApi.sendByUserMobile()
		} catch ({ errors }) {
			clearInterval(timer)
			this.txt = '获取验证码'
			this.disabled = false
		}
	}
}
